import axios from 'axios'
import Immutable from 'immutee'

import { getApiUrl, hasPandora } from '../utils/utils'

export const FETCH_BESTSELLERS = 'buyer/bestseller/FETCH_BESTSELLERS'
export const FETCH_BESTSELLERS_FAILURE =
  'buyer/bestseller/FETCH_BESTSELLERS_FAILURE'

const initialState = {
  fetched: false,
  result: [],
  error: null,
}

export default function reducer(state = initialState, action) {
  const immutable = Immutable(state)
  switch (action.type) {
    case FETCH_BESTSELLERS:
      return immutable.set('result', action.payload).set('fetched', true).done()

    case FETCH_BESTSELLERS_FAILURE:
      return immutable
        .set('error', action.payload)
        .set('result', [])
        .set('fetched', false)
        .done()
    default:
      return state
  }
}

export function fetchBestSellers(location) {
  const url = `${getApiUrl()}bestseller/${location.toLowerCase()}`
  const pandora = hasPandora()
  const requestConfig = {
    params: { pandora },
  }

  return dispatch => {
    return axios
      .get(url, requestConfig)
      .then(res => {
        dispatch({
          type: FETCH_BESTSELLERS,
          payload: res.data,
        })
      })
      .catch(err => {
        dispatch({
          type: FETCH_BESTSELLERS_FAILURE,
          payload: err.stack,
        })
      })
  }
}
